import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddress = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.00009 12.02C2.97759 7.0814 6.99149 2.99775 11.9684 3C16.9745 3.00225 20.9974 6.90815 20.9996 11.9975C20.9996 17.0352 17.0397 20.9478 12.0156 20.9996C7.07924 21.0491 3.02259 16.9789 3.00009 12.02ZM4.6673 11.9863C4.6583 16.0294 7.91622 19.3098 11.9661 19.3368C16.007 19.3638 19.3347 16.0609 19.3504 12.0065C19.3662 7.99488 16.0723 4.68296 12.0336 4.65596C7.98372 4.62896 4.67405 7.91838 4.6673 11.984V11.9863Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9976 9.59232C11.2101 10.3551 10.4158 11.1245 9.62162 11.894C9.52712 11.9863 9.43937 12.0853 9.33813 12.1685C8.91514 12.5172 8.32565 12.4992 7.97691 12.1325C7.64392 11.7815 7.63267 11.1898 7.97691 10.8005C8.2379 10.5058 8.52815 10.2358 8.80714 9.95681C9.59687 9.16483 10.3866 8.37285 11.1808 7.58537C11.7186 7.05214 12.2631 7.04764 12.8008 7.58312C13.829 8.60235 14.8527 9.62607 15.872 10.6543C16.3625 11.1493 16.4029 11.7523 15.9845 12.1573C15.5727 12.5577 14.9765 12.497 14.4792 12.0133C13.6423 11.1965 12.8008 10.3821 11.9931 9.59457L11.9976 9.59232Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9976 14.5894C11.3766 15.1901 10.7489 15.7976 10.1234 16.4051C10.0491 16.4771 9.97938 16.5559 9.90064 16.6211C9.56764 16.8978 9.10191 16.8821 8.82741 16.5919C8.56417 16.3151 8.55742 15.8471 8.82741 15.5411C9.03441 15.3094 9.26165 15.0956 9.48215 14.8751C10.1054 14.2519 10.7286 13.6264 11.3541 13.0032C11.7793 12.5825 12.2068 12.5802 12.6321 13.0009C13.442 13.8042 14.2498 14.6119 15.0553 15.4241C15.4422 15.8134 15.4737 16.2904 15.143 16.6099C14.8168 16.9248 14.3465 16.8776 13.9573 16.4951C13.2981 15.8494 12.6343 15.2081 11.9976 14.5872V14.5894Z",
			fill: "currentColor"
		})
	]
});
export default SvgAddress;
